import { CompactButton } from '@/components/buttons';
import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { CurbyAccordion } from '@/components/curby-accordion';
import { CustomContentSection } from '@/components/custom-content-section';
import { useLayoutContext } from '@/contexts';
import { PrimaryLayout } from '@/layouts/primary';
import { IconX } from '@tabler/icons-react';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { useMemo } from 'react';
import {
	AccordionLocation,
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';

export const HelpPage = () => {
	const router = useRouter();
	const navigate = useNavigate();
	const { isDesktop } = useLayoutContext();
	const closeButton = useMemo(
		() => (
			<CompactButton leftSection={<IconX />} onClick={() => router.history.back()}>
				Close
			</CompactButton>
		),
		[router]
	);
	const reportAnIssueButton = useMemo(
		() => (
			<StandardButton onClick={() => navigate({ to: '/report-issue' })}>
				Report an Issue
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout
			header={{ title: 'Help', children: closeButton }}
			footer={{ children: reportAnIssueButton }}
		>
			<ContentPanel>
				<CustomContentSection
					location={ContentSectionLocation.Help}
					placement={ContentSectionPlacement.Top}
				/>
				<CurbyAccordion title="Our Mission" accordionLocation={AccordionLocation.HelpMission} />
				<CurbyAccordion
					title="Soft Plastics Program"
					accordionLocation={AccordionLocation.HelpMaterialsWeRecycle}
				/>
				<CustomContentSection
					location={ContentSectionLocation.Help}
					placement={ContentSectionPlacement.Middle}
				/>
				<CurbyAccordion
					title="Other Materials"
					accordionLocation={AccordionLocation.HelpOtherMaterials}
				/>
				<CurbyAccordion
					title="Program Material"
					accordionLocation={AccordionLocation.HelpProgramMaterial}
				/>
				<CurbyAccordion title="Program" accordionLocation={AccordionLocation.HelpProgram} />
				<CustomContentSection
					location={ContentSectionLocation.Help}
					placement={ContentSectionPlacement.Bottom}
				/>
				{isDesktop && reportAnIssueButton}
			</ContentPanel>
		</PrimaryLayout>
	);
};
